import styled, { css } from 'styled-components';

const StyledCarouselContainer = styled.div `
  position: relative;
`;
const StyledCarouselViewport = styled.div `
  overflow: hidden;
`;
const StyledCarousel = styled.div `
  display: flex;
  gap: 1rem;
`;
const StyledCarouselButtonIconContainer = styled.div `
  transform: scale(100%);
  display: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    display: block;
  }
`;
const commonCarouselButtonStyles = css `
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 75px;
  z-index: ${props => props.theme.zIndex.minor};
  cursor: pointer;

  @media (pointer: fine) {
    &:hover ${StyledCarouselButtonIconContainer} {
      transform: scale(125%);
      transition-property: transform;
      transition-duration: ${props => props.theme.animation.duration.quick2};
      transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
    }
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.sm}) {
    display: none;
  }
`;
const StyledCarouselPrevButton = styled.div `
  ${commonCarouselButtonStyles};

  left: 0;
  background: ${props => props.theme.gradients.horizontalCarousel.prevButton};
`;
const StyledCarouselNextButton = styled.div `
  ${commonCarouselButtonStyles};

  right: 0;
  justify-content: flex-end;
  background: ${props => props.theme.gradients.horizontalCarousel.nextButton};
`;
const StyledPadding = styled.div ``;

export { StyledCarousel, StyledCarouselButtonIconContainer, StyledCarouselContainer, StyledCarouselNextButton, StyledCarouselPrevButton, StyledCarouselViewport, StyledPadding };
//# sourceMappingURL=HorizontalCarousel.styles.mjs.map
